/* © CNES */
import { property } from 'lodash';
import { transformExtent } from 'ol/proj';
import { filterSections } from '../../assets/config/filters/Referenciel';
import { START_DATE_TIME } from '../../components/shared/Constants';
import { GeoJsonPolygon } from '../../models/GeoJsonPolygon';

/**
 * Get Query Params for items requests from regards.
 * @param param each param to format for regards.
 * @param value each value of param that filter items accordingly.
 * @returns the query to interrogate regards items endpoint.
 */
export const getQueryParams = (param: string, value: any) => {
  const filter = Object.values(filterSections).find(
    (el) => el.param === param && el.param !== filterSections.dataProduct.param
  );
  switch (filter?.op) {
    case 'in':
      return {
        op: "in",
        "args": [
          {
            "property": param
          },
          [
            filterSections.whereAbsoluteOrbit.param,
            filterSections.whereRelativeOrbit.param,
          ].includes(filter.param)
            ? value.map(Number)
            : Array.isArray(value)
            ? value
            : [value],
        ]};
    case 'between':
      return {
        op: "between",
        "args": [
          {
            "property": param
          },
          parseInt(value[0]), parseInt(value[1])
        ]};
    case 'lte':
      if (filter.param == "start_datetime") {
        return {
          op: "<=",
          "args": [
            {
              "property": "datetime"
            },
            { "timestamp": value}
          ]};
      }
      return {
        op: "<=",
        "args": [
          {
            "property": param
          },
          value
        ]};
    case 'gte':
      if (filter.param == "end_datetime") {
        return {
          op: ">=",
          "args": [
            {
              "property": "datetime"
            },
            { "timestamp": value}
          ]};
      }
      return {
        op: ">=",
        "args": [
          {
            "property": param
          },
          value
        ]};
    case 'contains':
      return { [param]: { contains: value } };
  }
};

/**
 * build Bbox Regards.
 * @param bbox number[] the bbox to format.
 * @returns Extent.
 */
export const buildBboxRegards = (bbox: number[]) => {
  return transformExtent(bbox, 'EPSG:3857', 'EPSG:4326');
};

/**
 * Build the Query to interrogate regards search items endpoint.
 * @param params all params that filter the result from search items.
 * @param page the pagination of results from items on regards side.
 * @param bbox the bbox of map to filter items on view.
 * @returns the body to interrogate regards items endpoint.
 */
export const buildQueryParams = (
  params: Record<string, string[] | string | null>,
  bbox: number[] | undefined,
  token: string | null = null,
  intersects: GeoJsonPolygon | null
) => {
  let argsObj: Record<string, any>[] = [];
  Object.keys(params).forEach((k: string) => {
    const value: string[] | string | null = params[k];
    if (value && value.length > 0) {
      if (k != 'product:type') {
        const queryParamsResult: any = getQueryParams(k, value);
        argsObj.push(queryParamsResult);
      }
    }
  });

  let collections: any = null;
  collections = argsObj.find((obj: any) => obj?.args[0].property === "dataset");
  const filteredArgsObj = argsObj.filter((obj) => {
    if (obj === undefined) {
      return false; 
    }
    return obj.args?.[0]?.property !== "dataset";
  });
  collections = collections.args[1];
  /**
  // Extraire la valeur de "dataset" de argsObj et la supprimer
  let collections: string[] | null = null;
  if (argsObj.dataset && argsObj.dataset.in) {
    collections = argsObj.dataset.in;
    delete argsObj.dataset;
  }
  */
 let resultFilter: any = null
  if (filteredArgsObj.length > 0) {
    resultFilter = {
      "op": "and",
      "args": filteredArgsObj
    }
  }
  return {
    sortBy: [{ direction: 'desc', field: START_DATE_TIME }],
    limit: 20,
    token: token,
    collections: collections,
    filter: resultFilter,
    ...(bbox && { bbox: buildBboxRegards(bbox) }),
    ...(intersects && { intersects: intersects.features[0].geometry }),
  };
};
